import React from 'react'

import './style.css'

const Whitebox = ({ customStyle, children, cover, noPadding }) => (
    <div className="white-box no-padding" style={customStyle || {}}>
        {cover && <div>{cover}</div>}
        <div
            style={{
                padding: noPadding ? 0 : cover ? '41px 25px 25px 25px' : '25px',
                position: 'relative'
            }}>
            {children}
        </div>
    </div>
)

export default Whitebox
